module.exports = __webpack_public_path__ + "img/sesion-traning-icon.668141e6.svg";